module.exports = __webpack_public_path__ + "static/media/procedures.cab164f5.svg";